import React from 'react';
import RoleRibbon from '../role-ribbon/role-ribbon';
import { getExperienceTabsForRole } from '../role-ribbon/role-ribbon.config';

const ExperienceTabs = ({ role, navigate, translate }) => {
  const tabs = getExperienceTabsForRole(role);

  return <RoleRibbon tabs={tabs} navigate={navigate} translate={translate} />;
};

export default ExperienceTabs;